module.exports = __webpack_public_path__ + "img/hackernews.82bcf3ee.png";